import { graphql } from 'gql';

// --- UER ---

export const getUerContractHasOthersGql = graphql(`
    query getUerContractHasOthers($contractId: Long!) {
        uerContract(contractId: $contractId) {
            data {
                hasOthers
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractOtherCostsGql = graphql(`
    query uerContractOtherCosts(
        $contractId: Long!
        $constructionTypeId: Int!
        $skip: Int
        $take: Int
        $where: ContractOtherCostItemDataFilterInput
        $order: [ContractOtherCostItemDataSortInput!]
    ) {
        uerContractOtherCosts(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            skip: $skip
            take: $take
            where: $where
            order: $order
        ) {
            items {
                key
                isInUse
                canDelete
                canEdit
                calculatingType
                calculatingTypeValue
                chapter
                constructionTypeId
                contractId
                constructionTypeLimits {
                    relationStatus
                }
                id
                isGlobalOtherCost
                isIncludedInActKc2
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                name
                section
                status
                isEditable
                seasonLimits {
                    cost
                    seasonId
                }
                hasEmptyFormula
                hasEmptyOtherCostType
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerDeleteContractOtherCostGql = graphql(`
    mutation uerDeleteContractOtherCost($contractOtherCostId: Long!) {
        uerDeleteContractOtherCost(contractOtherCostId: $contractOtherCostId) {
            result
            message
            id
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

// --- BIM ---

export const bimContractOtherCostsGql = graphql(`
    query bimContractOtherCosts(
        $constructionTypeId: Int!
        $contractId: Long!
        $skip: Int
        $take: Int
        $where: BimContractOtherCostItemDataFilterInput
        $order: [BimContractOtherCostItemDataSortInput!]
    ) {
        bimContractOtherCosts(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            skip: $skip
            take: $take
            where: $where
            order: $order
        ) {
            items {
                constructionTypeId
                cost
                isIncludedInWorkOrder
                isIncludedInActKc2
                id
                contractId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                isGlobalOtherCost
                isIncludedInWorkOrderChange
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimDeleteContractOtherCostGql = graphql(`
    mutation bimDeleteContractOtherCost($contractOtherCostId: Long!) {
        bimDeleteContractOtherCost(contractOtherCostId: $contractOtherCostId) {
            result
            message
            id
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimContractOtherNameFilterGql = graphql(`
    query bimContractOtherCostNameFilter(
        $constructionTypeId: Int!
        $contractId: Long!
        $order: [FilterValueOfStringSortInput!]
        $skip: Int
        $take: Int
        $where: FilterValueOfStringFilterInput
    ) {
        bimContractOtherCostNameFilter(
            skip: $skip
            take: $take
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerRemoveUnusedContractOtherCostsGql = graphql(`
    mutation uerRemoveUnusedContractOtherCosts($contractId: Long!) {
        uerRemoveUnusedContractOtherCosts(contractId: $contractId) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerContractOtherCostNameFilter = graphql(`
    query uerContractOtherCostNameFilter(
        $contractId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        uerContractOtherCostNameFilter(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const uerContractOtherCostCalculatingTypeFilter = graphql(`
    query uerContractOtherCostCalculatingTypeFilter(
        $contractId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfOtherCostCalculationTypeEnumFilterInput
        $order: [FilterValueOfOtherCostCalculationTypeEnumSortInput!]
    ) {
        uerContractOtherCostCalculatingTypeFilter(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const uerContractOtherCostStatusFilter = graphql(`
    query uerContractOtherCostStatusFilter(
        $contractId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfContractOtherStatusEnumFilterInput
        $order: [FilterValueOfContractOtherStatusEnumSortInput!]
    ) {
        uerContractOtherCostStatusFilter(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const uerContractOtherRelationStatusFilter = graphql(`
    query uerContractOtherRelationStatusFilter(
        $contractId: Long!
        $constructionTypeId: Int!
        $where: FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput
        $order: [FilterValueOfContractOtherConstructionTypeRelationStatusEnumSortInput!]
    ) {
        uerContractOtherRelationStatusFilter(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);
